import { useEffect, useState } from "react";

/**
 * Bas acara ringkas untuk ekspresi Mickey AI.
 * mood: "idle" | "thinking" | "happy"
 * setMickeyMood("happy", 3000) -> kembali "idle" selepas 3 saat.
 */
let current = "idle";
let timer = null;
const subs = new Set();

export function setMickeyMood(mood, ms) {
  clearTimeout(timer);
  current = mood || "idle";
  subs.forEach((f) => f(current));
  if (ms) timer = setTimeout(() => setMickeyMood("idle"), ms);
}

/** Gembira seketika (cth laporan berjaya dihantar). */
export const celebrateMickey = (ms = 3200) => setMickeyMood("happy", ms);

export function useMickeyMood() {
  const [m, setM] = useState(current);
  useEffect(() => {
    subs.add(setM);
    setM(current);
    return () => subs.delete(setM);
  }, []);
  return m;
}

// Untuk ujian/debug: window.__setMickeyMood("thinking")
if (typeof window !== "undefined") window.__setMickeyMood = setMickeyMood;
